query findPlayerSetupMarketByCode(
  $eventId: UUID!
  $marketsCondition: MarketCondition,
  $marketsFilter: MarketFilter
) {
  event: eventByEventId(eventId: $eventId) {
    markets: marketsByEventId(
      condition: $marketsCondition,
      filter: $marketsFilter,
    ) {
      nodes {
        displayStatus
        offeringStatus
        resultingStatus
        marketCode
        marketId
        marketType
        selections
        source
        inPlay
        marketSummary
        limitConfiguration
        gateway
      }
    }
  }
}
